<div *ngIf="showSpinner" class="loading-spinner">
  <mat-progress-spinner class="spinner" [mode]="'indeterminate'"></mat-progress-spinner>
</div>